module.exports = __webpack_public_path__ + "img/news8.afdda4d5.jpg";